
<div class="dialog-component">
  <div class="cross">
    <button
      id="desktop-focus-phone"
      tabindex="0"
      type="button"
      class="close close-btn"
      aria-label="Close"
      (click) ="dialogData.reset()"
    ></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button
        id="mob-focus-phone"
        tabindex="0"
        type="button"
        class="close close-btn"
        aria-label="Close"
        (click) ="dialogData.reset()"
      ></button>
    </div>
    <div class="edit-nationality-body">
      <div class="modal-form-group">
        <label class="dob-label">Emergency contact number:</label>
        <div class="cannot-edit-profile-rectangle">

          <input sanitizeInputForm class="form-input" [(ngModel)]="dialogData.emergencyContactNumber" OnlyNumber="true"
            maxlength="15" minlength="9" placeholder="Enter emergency contact number"
            [formControl]="dialogData.emergencyContactNumberControl">


            @if (dialogData.emergencyContactNumberControl.invalid) {
              <div class="red no-margin">
                @if (dialogData.emergencyContactNumberControl.errors!.required && dialogData.emergencyContactNumberControl.dirty) {
                  <div
                    >
                    Emergency contact number cannot be blank
                  </div>
                }
                @if (!dialogData.emergencyContactNumberControl.errors!.required && (dialogData.emergencyContactNumberControl.errors!.minlength || dialogData.emergencyContactNumberControl.errors!.forbiddenName) && dialogData.emergencyContactNumberControl.dirty) {
                  <div
                    >
                    Sorry, that is not a valid phone number
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="btn-container nationality-button">
          <button role="button" tabindex="0" aria-label="save" class="send-button" (click)="dialogData.saveEmergencyContactNumber(dialogData.emergencyContactNumber)"
          >Save</button>
        </div>
      </div>
